import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import logger from '../../utils/logger';
import { fetchDatasetContents } from '../../services/datasetContentService';
import { DEFAULT_PAGE_LIMIT } from '../../constants/apiEndpoints';

export const navigateToFolderWithPagination = createAsyncThunk(
    'datasetContent/navigatePaginated',
    async ({ datasetId, path, page = 1, search }, { rejectWithValue }) => {
        try {
            logger.debug(`Navigating to datasetId: ${datasetId}, path: ${path}, page: ${page}, search: ${search}`);
            const result = await fetchDatasetContents(datasetId, path, { page, limit: DEFAULT_PAGE_LIMIT, search });
            return result;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const datasetContentSlice = createSlice({
    name: 'datasetContent',
    initialState: {
        currentDataset: null,
        contents: [],
        breadcrumb: [],
        currentPath: '/',
        currentPage: 1,
        currentSearch: '',
        totalPagesAtLevel: 1,
        totalItemsAtLevel: 0,
        hasNextPage: false,
        hasPrevPage: false,
        totalFilesInDataset: 0,
        isLoading: false,
        error: null,
        isPaginated: true
    },
    reducers: {
        clearDatasetContent: (state) => {
            state.currentDataset = null;
            state.contents = [];
            state.breadcrumb = [];
            state.currentPath = '/';
            state.currentPage = 1;
            state.currentSearch = '';
            state.totalPagesAtLevel = 1;
            state.totalItemsAtLevel = 0;
            state.hasNextPage = false;
            state.hasPrevPage = false;
            state.totalFilesInDataset = 0;
            state.error = null;
            state.isPaginated = true;
        },
        resetToRoot: (state) => {
            state.currentPath = '/';
            state.currentPage = 1;
            state.currentSearch = '';
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(navigateToFolderWithPagination.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(navigateToFolderWithPagination.fulfilled, (state, action) => {
                const payload = action.payload;
                
                state.isLoading = false;
                state.contents = payload.items || [];
                state.breadcrumb = payload.breadcrumb || [];
                state.currentDataset = payload.datasetId;
                state.currentPath = payload.path;
                state.currentPage = payload.currentPage;
                state.currentSearch = action.meta?.arg?.search || '';
                state.totalPagesAtLevel = payload.totalPagesAtLevel;
                state.totalItemsAtLevel = payload.totalItemsAtLevel;
                state.hasNextPage = payload.hasNextPage;
                state.hasPrevPage = payload.hasPrevPage;
                state.totalFilesInDataset = payload.totalFilesInDataset;
                state.error = null;
            })
            .addCase(navigateToFolderWithPagination.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    }
});

export const { clearDatasetContent, resetToRoot } = datasetContentSlice.actions;
export default datasetContentSlice.reducer;